import { NodeWithMultipleHandles } from '../NodeWithMultipleHandles';

export const PtMgmtNode = (props) => {
    return <NodeWithMultipleHandles {...props} nodeType="ptmgmt" />;
};
